<template>
    <Transition
        enter-active-class="transition ease-out duration-300"
        enter-from-class="translate-y-2 opacity-0"
        enter-to-class="translate-y-0 opacity-100"
        leave-active-class="transition ease-in duration-200"
        leave-from-class="translate-y-0 opacity-100"
        leave-to-class="translate-y-2 opacity-0"
    >
        <div v-if="visible"
             class="fixed bottom-6 right-6 z-50 flex items-center gap-2.5 rounded-lg bg-gray-900 px-4 py-3 text-sm text-white shadow-lg">
            <CheckCircleIcon v-if="type === 'success'" class="h-5 w-5 text-green-400 flex-shrink-0" />
            <ExclamationTriangleIcon v-if="type === 'error'" class="h-5 w-5 text-red-400 flex-shrink-0" />
            <InformationCircleIcon v-if="type === 'info'" class="h-5 w-5 text-blue-400 flex-shrink-0" />
            <span>{{ message }}</span>
        </div>
    </Transition>
</template>

<script>
import { CheckCircleIcon, ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/vue/20/solid'

export default {
    components: { CheckCircleIcon, ExclamationTriangleIcon, InformationCircleIcon },

    data() {
        return {
            visible: false,
            message: '',
            type: 'success',
            timer: null,
        }
    },

    methods: {
        show(message, type = 'success', duration = 2500) {
            if (this.timer) clearTimeout(this.timer);
            this.message = message;
            this.type = type;
            this.visible = true;
            this.timer = setTimeout(() => {
                this.visible = false;
            }, duration);
        },
    },
}
</script>
